import { extendTheme, type ThemeConfig } from "@chakra-ui/react";

import { nvpTokens } from "@/design-system/tokens";

const config: ThemeConfig = {
  initialColorMode: "dark",
  useSystemColorMode: false
};

const bodyFont =
  "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif";
const gameFont = "'Lilita One', Inter, ui-sans-serif, system-ui, sans-serif";

export const theme = extendTheme({
  config,
  styles: {
    global: {
      "html, body, #root": {
        minHeight: "100%",
        background: nvpTokens.color.surface.base
      },
      body: {
        color: "white",
        fontFamily: bodyFont,
        margin: 0,
        textRendering: "optimizeLegibility"
      },
      "*, *::before, *::after": {
        boxSizing: "border-box"
      },
      "a, button": {
        WebkitTapHighlightColor: "transparent"
      },
      "::selection": {
        background: "rgba(255, 79, 216, 0.35)"
      }
    }
  },
  colors: {
    nvp: {
      ink: nvpTokens.color.surface.base,
      deep: nvpTokens.color.primary.deepBackground,
      panel: nvpTokens.color.surface.elevated,
      panelGlass: nvpTokens.color.surface.glass,
      cyan: nvpTokens.color.primary.electricBlue,
      blue: "#5b7dff",
      pink: nvpTokens.color.primary.neonPink,
      violet: nvpTokens.color.primary.cosmicViolet,
      yellow: nvpTokens.color.primary.brightYellow,
      green: nvpTokens.color.primary.matrixGreen,
      danger: nvpTokens.color.semantic.danger
    }
  },
  fonts: {
    heading: gameFont,
    body: bodyFont
  },
  radii: {
    nvp: nvpTokens.radius.card
  },
  shadows: {
    neonPink: nvpTokens.glow.pink,
    neonBlue: nvpTokens.glow.blue,
    neonYellow: nvpTokens.glow.yellow,
    panel: "0 24px 80px rgba(0, 0, 0, 0.36)"
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: nvpTokens.radius.control,
        fontFamily: gameFont,
        letterSpacing: "0",
        fontWeight: 400
      }
    }
  }
});
